<template>
  <UiToastHost v-if="newUiEnabled" />

  <Teleport v-else to="body">
    <div :class="placement" class="toast-container position-fixed p-3">
      <BToast
        v-for="notification in notifications"
        :key="`notification-${notification.id}`"
        :model-value="isVisible(notification)"
        :variant="notificationType(notification)"
        @hide="closeNotification(notification)"
        @click="handleNotificationClick(notification, $event)"
      >
        <template #default>
          <span>{{ notification?.text }}</span>
          <router-link
            v-if="notification?.link"
            :to="notification.link"
            class="ms-2 text-decoration-underline notification-link"
            @click.stop
          >
            {{ $t("Go") }} &rarr;
          </router-link>
        </template>
      </BToast>
    </div>
  </Teleport>
</template>

<script>
import { mapGetters } from "vuex";
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

export default {
  name: "Notifications",

  setup() {
    return { newUiEnabled: useNewUiEnabled() };
  },

  computed: {
    ...mapGetters({
      notifications: "notifications/notifications",
      notificationsPlacement: "notifications/notificationPlacement",
    }),

    placement() {
      const className = {
        "top-right": "top-0 end-0",
        "top-left": "top-0 start-0",
        "bottom-right": "bottom-0 end-0",
        "bottom-left": "bottom-0 start-0",
      };

      const userPlacement = this.notificationsPlacement || "top-right";

      return className[userPlacement];
    },
  },

  methods: {
    closeNotification(notification) {
      this.$store.commit("notifications/clearNotification", notification);
    },

    handleNotificationClick(notification, event) {
      const target = event?.target;
      if (!(target instanceof Element) || !target.closest(".notification-link")) {
        this.closeNotification(notification);
      }
    },

    isVisible(notification) {
      return notification ? 5000 : false;
    },

    notificationType(notification) {
      return notification?.type == "error" ? "danger" : notification?.type;
    },
  },
};
</script>

<style scoped>
.notification-link {
  color: inherit;
  font-weight: 600;
}
</style>
